/**
 * @file SearchClosedBanner.tsx
 * @description Красная плашка «Сайт закрыт от поисковиков» над шапкой
 * кабинета магазина (phase19.16, партия Р3в, v0.19.64; SB145, SB132;
 * uiux-r3 §3.5). Стоит в слоте `AppShell.banner` рядом с плашкой «Сайт
 * закрыт для покупателей» (SB138) — это разные причины (SB132), поэтому две
 * полосы, а не одна. Видна на всех страницах кабинета, пока в настройках SEO
 * запрещена индексация; «Открыть →» ведёт в «Сайт → SEO».
 *
 * До sm — одна строка «Сайт закрыт от поисковиков · Открыть →» (QA Р3в: две
 * закреплённые плашки на 360 съедали половину экрана — с плашкой PL8 «Магазин
 * ещё не открыт» вместе); пояснение и кнопка — с sm. Ссылка — 44 px.
 */

import { SearchX } from "lucide-react";
import { Link } from "react-router";

import { Button } from "../ui/button";

const BANNER_CLASS =
  "flex items-center gap-x-3 gap-y-2 bg-[var(--danger-soft)] px-4 py-1 text-on-surface [box-shadow:inset_0_-1px_0_var(--destructive-line)] sm:flex-wrap sm:py-2";

/** Текст плашки (один на кабинет и «Проверку сайта»). */
export const SEARCH_CLOSED_TITLE = "Сайт закрыт от поисковиков";
export const SEARCH_CLOSED_TEXT = "Яндекс и Google не показывают его в поиске, пока индексация запрещена в настройках SEO.";

export function SearchClosedBanner({ slug }: { slug: string }) {
  return (
    <div role="region" aria-label="Сайт в поиске" data-testid="search-closed-banner" className={BANNER_CLASS}>
      <SearchX className="size-5 shrink-0 text-destructive" aria-hidden />
      <p className="type-body min-w-0 flex-1 truncate sm:whitespace-normal">
        <strong className="font-semibold">{SEARCH_CLOSED_TITLE}</strong>
        <span className="hidden md:inline md:before:content-['_·_']">{SEARCH_CLOSED_TEXT}</span>
      </p>
      {/* До sm — ссылкой в той же строке; с sm — кнопкой. */}
      <Link to={`/shop/${slug}/site/seo`} className="type-body inline-flex min-h-11 shrink-0 items-center font-medium text-primary hover:underline sm:hidden">
        Открыть →
      </Link>
      <Button asChild variant="outline" className="hidden shrink-0 sm:inline-flex">
        <Link to={`/shop/${slug}/site/seo`}>Открыть →</Link>
      </Button>
    </div>
  );
}
